import { Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import WhatsAppButton from '../components/layout/WhatsAppButton';
import { useEffect } from 'react';
import usePushNotifications from '../hooks/usePushNotifications';

// Public-facing layout — applied to all non-portal pages
const MainLayout = () => {
  const { pathname, hash } = useLocation();

  // Mount the push-notifications lifecycle once for the whole authed
  // session. Hook is a no-op for guests; for signed-in users with
  // pre-granted permission, it silently re-registers their FCM token.
  usePushNotifications();

  // Scroll behaviour on every URL change:
  //   ─ if the URL has a #hash and an element with that id exists,
  //     smooth-scroll to it (footer "Find a Centre" → #where-we-operate,
  //     About leadership deep-link → #leadership, etc.);
  //   ─ otherwise scroll to the top of the page.
  // Re-runs on hash changes too so hash-only navigations (same path,
  // different anchor) are handled. Two-arg fallback for old Safari which
  // silently ignores `{ behavior: 'instant' }`.
  useEffect(() => {
    if (hash) {
      const id = hash.replace(/^#/, '');
      // Wait one frame so the freshly-mounted target has a layout box.
      requestAnimationFrame(() => {
        const el = id ? document.getElementById(id) : null;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        window.scrollTo(0, 0);
      });
      return;
    }
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, hash]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      <WhatsAppButton />
    </Box>
  );
};

export default MainLayout;
